/* eslint-disable no-param-reassign */
import { GetServerSideProps } from 'next';

import { wrapper } from 'src/redux/store/store';
import MainContainer from 'components/MainContainer';
import { ServerSideRenderingContext } from 'types/objectTypes';
import { SentryWrapper } from 'lib/sentry';
import withMiddleware, { commonMiddleware } from 'src/shared/lib/middleware/combiner';

const handler = async ({
  query,
}: ServerSideRenderingContext): Promise<any> => {
  try {
    const { slug, ...restQuery } = query || {};

    if (!slug) {
      return { notFound: true };
    }

    const filteredRestQuery = Object
      .entries(restQuery)
      .reduce((store, [key, value]) => {
        if (Array.isArray(value)) {
          store[key] = value.join(',');
        }

        if (value) {
          store[key] = value;
        }

        return store;
      }, {});
    const queryParameters = new URLSearchParams(filteredRestQuery).toString();
    const queryParametersWithQuestion = queryParameters ? `?${queryParameters}` : '';
    const trailingSlash = (slug.includes('blog') || slug.includes('horoscope')) ? '/' : '';
    const destination = `${process.env.BASE_SERVER_URL}/${slug}${trailingSlash}${queryParametersWithQuestion}`;

    return { redirect: { destination, permanent: false } };
  } catch (e) {
    SentryWrapper.captureException(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(handler, { prior: commonMiddleware }));

export default MainContainer;
